import { FC } from "react";
import { useSelector } from "react-redux";

import type { ButtonTypes } from "web/types/Utils";

import { useCheckoutContext } from "web/context/checkout";

import { Box, Button, SxProps, Theme } from "@mui/material";

interface ICheckoutAsideButtonNextProps {
  text: string;
  to?: string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  type?: ButtonTypes;
  disabled?: boolean;
  dataT1?: string;
  hasFullWidth?: boolean;
}

const CheckoutAsideButtonNext: FC<ICheckoutAsideButtonNextProps> = ({
  text,
  to = "",
  sx = {},
  onClick,
  type = "submit",
  disabled = false,
  dataT1 = "button_next",
  hasFullWidth = false,
}) => {
  const { editProductId } = useCheckoutContext();
  const financingSourcesWarning = useSelector(
    ({ financingSources }) => financingSources.warning
  );

  return (
    <Box data-testid="checkout-aside-buttonNext">
      <Button
        variant="contained"
        size="large"
        sx={sx}
        href={to}
        type={type}
        disabled={disabled || !!editProductId || !!financingSourcesWarning}
        data-t1={dataT1}
        fullWidth={hasFullWidth}
        onClick={onClick}
      >
        {text}
      </Button>
    </Box>
  );
};

export default CheckoutAsideButtonNext;
